import { render, staticRenderFns } from "./MatchNotes.vue?vue&type=template&id=19614623&scoped=true&"
import script from "./MatchNotes.vue?vue&type=script&lang=js&"
export * from "./MatchNotes.vue?vue&type=script&lang=js&"
import style0 from "./MatchNotes.vue?vue&type=style&index=0&id=19614623&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19614623",
  null
  
)

export default component.exports